module.exports = __webpack_public_path__ + "img/k-1.3bd193fe.png";